module.exports = __webpack_public_path__ + "media/select2.eee4c828.mp3";